import { render, staticRenderFns } from "./ScripticItemLocation.vue?vue&type=template&id=06f64895"
import script from "./ScripticItemLocation.vue?vue&type=script&lang=ts"
export * from "./ScripticItemLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports